import { render, staticRenderFns } from "./BpcFormCreateContact.vue?vue&type=template&id=0d4d5d20&"
import script from "./BpcFormCreateContact.vue?vue&type=script&lang=js&"
export * from "./BpcFormCreateContact.vue?vue&type=script&lang=js&"
import style0 from "./BpcFormCreateContact.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports